import { SAVE_SUPPLIERS } from "./types";
import {SupplierConfig} from "../../models/supplier-config.model";

export const saveSuppliers = (content: SupplierConfig[]) => ({
    type: SAVE_SUPPLIERS,
    payload: content
});
